import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function getAllSuperviorsApi() {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.supervisors,
    method: 'get',
  }));
}

export function addNewSupervisorApi(payload) {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.addSupervisor,
    method: 'post',
    payload: payload
  }));
}

export function editSupervisorApi(payload, id) {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.supervisors + `/${id}`,
    method: 'put',
    payload: payload
  }));
}

export function deleteSupervisorApi(id) {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + `/${id}`,
    method: 'delelte',
  }));
}